export {
  ContentCard,
  type ContentCardProps,
} from '../../compositions/shared/ContentCard';
